import React from 'react';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'outline' | 'glow';
  className?: string;
  icon?: React.ReactNode;
}

export const Badge: React.FC<BadgeProps> = ({
  children,
  variant = 'default',
  className = '',
  icon,
}) => {
  const variants = {
    default: 'bg-bg-tertiary text-text-secondary border-border-subtle',
    outline: 'bg-transparent text-text-secondary border-border-subtle',
    glow: 'bg-apple-blue/10 text-apple-blue border-apple-blue/30',
  };

  return (
    <span
      className={`
        inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full 
        border text-body-s font-medium
        transition-all duration-300
        ${variants[variant]}
        ${className}
      `}
    >
      {icon && <span className="flex-shrink-0">{icon}</span>}
      {children}
    </span>
  );
};

export default Badge;
